import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

interface ConfirmDialogProps {
    title: string;
    children: string | React.ReactNode;
    open: boolean;
    close: () => void;
    onConfirm: () => void;
}

export const ConfirmDialog = ({ title, children, open, close, onConfirm }: ConfirmDialogProps) => {
    return (
        <Dialog open={open} onClose={() => close()} aria-labelledby="confirm-dialog">
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => close()} color="secondary">
                    No
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        close();
                        onConfirm();
                    }}
                    color="default"
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};
